import JobsGreen from "../JobBoardOuter/JobsGreen";

const JobBoardInnerGreen = () => {


    return (
        <div>
           <JobsGreen></JobsGreen>
        </div>
    );
};

export default JobBoardInnerGreen;
